import { createAsyncThunk } from '@reduxjs/toolkit';

import { ICourseCreditTransferLog } from '.';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';

export type TAdminGetCourseCreditTransferLogs = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  studentId?: string;
  fromCourseId?: string;
  toCourseId?: string;
  startDate?: string;
  endDate?: string;
};

const apiDataProvider = new APIDataProvider();

export const adminGetCourseCreditTransferLogs = createAsyncThunk(
  '/admin/course-credit-transfer-logs/list',
  async ({
    limit,
    offset,
    sortKey,
    sortValue,
    studentId,
    fromCourseId,
    toCourseId,
    startDate,
    endDate,
  }: TAdminGetCourseCreditTransferLogs) => {
    let path = `${AdminApiPaths.courseCreditTransferLogs}?limit=${limit}&offset=${offset}`;

    if (sortKey) {
      path += `&sortKey=${sortKey}`;
    }

    if (sortValue) {
      path += `&sortValue=${sortValue}`;
    }

    if (studentId) {
      path += `&studentId=${studentId}`;
    }

    if (fromCourseId) {
      path += `&fromCourseId=${fromCourseId}`;
    }

    if (toCourseId) {
      path += `&toCourseId=${toCourseId}`;
    }

    if (startDate) {
      path += `&startDate=${startDate}`;
    }

    if (endDate) {
      path += `&endDate=${endDate}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<TApiPaginationResponse<ICourseCreditTransferLog>>
    >(path);

    return response.data;
  }
);
